module.exports = __webpack_public_path__ + "static/workplace-compliance-and-remote-work-a471c2f8d48263ccdfc869f45f08ab09.png";